import type { ForumTag } from './types';

export const forumTags = [
  'Announcements',
  'FreelanceLife',
  'VisualCommunication',
  'DigitalDesign',
  'Photography',
  'Audiovisual',
  'LanguageAndCommunication',
  'ItDevelopment',
  'PerformingArtists',
  'OnlineContentCreation',
] as const;

/** Admin-only tags can not be picked by users when creating a post. */
export const isAdminOnlyForumTag = (tag: ForumTag): boolean => tag === 'Announcements';
